import { AlignLeft, ListSelect } from 'iconoir-react';
import type { ReactNode } from 'react';
import { wellSurface } from '@/components/web-fe/design-v2/surfaces';
import { documentKeyPoints } from '@/components/shared-ui/document-insights';
import { cn } from '@listening/utils/react-helpers';
import * as m from '@/paraglide/messages';

export function DocumentInsightsResult({
  description,
  summary,
  keyPoints,
}: {
  description?: string | null;
  summary?: string | null;
  keyPoints?: string | null;
}) {
  const points = documentKeyPoints(keyPoints);
  return (
    <div aria-live='polite' className='flex flex-col gap-9 px-6 pt-1 pb-14'>
      {description && (
        <p className='text-[15px] leading-[1.65] text-[var(--v2-text-primary)]'>
          {description}
        </p>
      )}
      {summary && (
        <InsightsSection
          icon={<AlignLeft className='size-4' />}
          title={m.read_along_ai_summary()}
        >
          <p className='text-[15px] leading-[1.75] text-[var(--v2-text-primary)]'>
            {summary}
          </p>
        </InsightsSection>
      )}
      {points.length > 0 && (
        <InsightsSection
          icon={<ListSelect className='size-4' />}
          title={m.read_along_ai_key_points()}
        >
          <ul className='flex flex-col gap-2.5'>
            {points.map((point, index) => (
              <li
                key={index}
                className={cn(
                  wellSurface,
                  'rounded-[14px] px-4 py-4 text-[14px] leading-[1.6] text-[var(--v2-text-primary)]',
                )}
              >
                {point}
              </li>
            ))}
          </ul>
        </InsightsSection>
      )}
    </div>
  );
}

function InsightsSection({
  icon,
  title,
  children,
}: {
  icon: ReactNode;
  title: string;
  children: ReactNode;
}) {
  return (
    <section className='flex flex-col gap-3'>
      <h3 className='flex items-center gap-2 text-[14px] font-semibold tracking-[-0.01em] text-[var(--v2-text-primary)]/70'>
        <span aria-hidden className='shrink-0'>
          {icon}
        </span>
        {title}
      </h3>
      {children}
    </section>
  );
}
